import { pickIfCode, resolveChannelIcon } from '@/utils/channelIcon'

export default {
  data () {
    return {
      channelIfCode: ''
    }
  },
  computed: {
    channelIcon () {
      return resolveChannelIcon(this.channelIfCode)
    },
    merchantAvatar () {
      return this.channelIcon || this.avatar || this.payImg || ''
    }
  },
  methods: {
    bindChannelAvatar (res) {
      this.channelIfCode = pickIfCode(res)
    }
  }
}
